import * as React from 'react';
import Contacts, { Props } from '@websky/core/src/Contacts/components/Contacts';

const CheckoutContacts: React.FC<Props> = props => {
	return <Contacts {...props} variant="standard" showSubscribeCheckbox={false} />;
};

export default CheckoutContacts;
